/**
 * Movimento do carro em `CAR_HOLD` (RN-BF-058): pneus girando e oscilação de estrada.
 *
 * Função pura, para a `BossFinalScene` e a tela de espera do telão usarem a mesma regra
 * (sem cópia de constante). `msDesdeOCarHold < 0` é antes do `CAR_HOLD`: sem movimento.
 *
 * @param {number} msDesdeOCarHold
 * @returns {{ roadOffset: number, tireRotation: number }} `tireRotation` é o valor de
 *   `tire.setRotation` (negativo = anti-horário, uma volta a cada 2 s); `roadOffset` é o
 *   deslocamento vertical em px, de no máximo 3, compartilhado por carroceria e pneus.
 */
const TIRE_ROTATION_MS = 2_000;

const clamp01 = (value) => Math.min(1, Math.max(0, value));
const easeOutCubic = (value) => 1 - Math.pow(1 - value, 3);

export function getCarHoldMotion(msDesdeOCarHold) {
    if (!(msDesdeOCarHold > 0)) return { roadOffset: 0, tireRotation: 0 };
    const seconds = msDesdeOCarHold / 1000;
    const roadOffset = easeOutCubic(clamp01(seconds / 0.6))
        * (2 * Math.sin(seconds * Math.PI * 2 / 0.9)
            + Math.sin(seconds * Math.PI * 2 / 0.37));
    const tireRotation = -((msDesdeOCarHold % TIRE_ROTATION_MS) / TIRE_ROTATION_MS) * Math.PI * 2;
    return { roadOffset, tireRotation };
}
